import { Environment } from '@rma/generic/util/environment';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';

export const provideRecaptchaSettings = () => ({
  provide: RECAPTCHA_SETTINGS,
  deps: [Environment],
  useFactory: (environment: Environment) => ({ siteKey: environment.recaptchaSiteKey }) satisfies RecaptchaSettings,
});
